import React from 'react';
import Grid from "@mui/material/Grid";
import CustomMultiText from "../../widgets/inputs/CustomMultiText";
import {questionRequired} from "../../../utils/RegisterUtils";
import {Button, Divider, MenuItem, Paper, TextField} from "@mui/material";
import MUIRichTextEditor from "../../widgets/inputs/MUIRichTextEditorCompat";
import {convertFromRaw, convertToRaw} from "draft-js";
import CustomSelect from "../../widgets/inputs/CustomSelect";
import {categoriesV2} from "../../../utils/dictionaries/Categories";
import { Autocomplete } from '@mui/material';
import Typography from "@mui/material/Typography";
import AccordionFaq from "./AccordionFaq";
import {stateToHTML} from "draft-js-export-html";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {useFormContext} from "react-hook-form";
import {useTheme} from "@mui/styles";
import {PaperComponent} from "../../../styles/components/DynamicComponentStyle";

const emojis = [
	{
		keys: ["face", "grin"],
		value: "😀",
		content: "😀",
	},
	{
		keys: ["face", "joy"],
		value: "😂",
		content: "😂",
	},
	{
		keys: ["face", "sweat"],
		value: "😅",
		content: "😅",
	}
]

const FaqForm = ({tags, setTags, handleKeyDown, onSubmit, showPreview = false, risposta, isDefault}) => {
	const classes = BaseStyle();
	const theme = useTheme();
	const {register, errors, watch, handleSubmit, setValue, control} = useFormContext();

	return (
		<React.Fragment>
			<form onSubmit={handleSubmit(onSubmit)} className={classes.padding2}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<CustomMultiText
							inputRef={register(questionRequired)}
							name={"domanda"}
							label={"Domanda"}
							autoFocus={false}
							error={errors["domanda"]}
							rows={2}
						/>
					</Grid>
					<Grid item xs={12}>
						<Paper variant={"outlined"}
						       style={{
							       minHeight: 300,
							       padding: 8,
							       paddingLeft: 14,
							       paddingRight: 14,
							       borderColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"
						       }}>
							{
								isDefault ?
									<MUIRichTextEditor
										inlineToolbar
										defaultValue={risposta}
										label="Risposta"
										controls={["title", "bold", "italic", "underline", "strikethrough", "undo", "redo", "link", "numberList", "bulletList", "quote", "code", "clear"]}
										autocomplete={{
											strategies: [
												{
													items: emojis,
													triggerChar: ":"
												}
											]
										}}
										onChange={value => {
											const content = JSON.stringify(
												convertToRaw(value.getCurrentContent())
											);
											setValue("risposta", content);
										}}
									/> :
									<MUIRichTextEditor
										inlineToolbar
										label="Risposta"
										controls={["title", "bold", "italic", "underline", "strikethrough", "undo", "redo", "link", "numberList", "bulletList", "quote", "code", "clear"]}
										autocomplete={{
											strategies: [
												{
													items: emojis,
													triggerChar: ":"
												}
											]
										}}
										onChange={value => {
											const content = JSON.stringify(
												convertToRaw(value.getCurrentContent())
											);
											setValue("risposta", content);
										}}
									/>}
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<CustomSelect
							name={"categoria"}
							label={"Di che categoria fa parte?"}
							control={control}
							defaultValue={""}
							autoFocus={false}
							none={true}
							noneValue={""}
							rules={{required: true}}
							error={errors["categoria"]}
						>
							{Object.entries(categoriesV2).sort((a, b) => {
								if (a["1"].label > b["1"].label) return 1;
								if (a["1"].label < b["1"].label) return -1;
								return 0
							}).map(([key, val]) => {
								return (
									<MenuItem value={key} key={key}>
										{val.label}
									</MenuItem>
								);
							})}
						</CustomSelect>
					</Grid>
					<Grid item xs={12}>
						<Autocomplete
							multiple
							freeSolo
							options={[]}
							getOptionLabel={option => option || option}
							value={tags}
							onChange={(event, newValue) => setTags(newValue)}
							filterSelectedOptions
							renderInput={params => {
								params.inputProps.onKeyDown = handleKeyDown;
								return (
									<TextField
										{...params}
										variant="outlined"
										label="Parole chiave o tag da assegnare alla FAQ"
										required
										fullWidth
									/>
								);
							}}
							PaperComponent={PaperComponent}
						/>
					</Grid>
					{showPreview && <Grid item xs={12} className={classes.flexRight}>
						<Button disableElevation variant={"contained"} color={"primary"}
						        className={classes.roundButton} size={"small"}
						        type={"submit"} onClick={handleSubmit(onSubmit)}>
							<b>Crea FAQ</b>
						</Button>
					</Grid>}
					{watch("domanda")?.length > 0 && watch("risposta")?.length > 0 && showPreview &&
					<Grid item xs={12} className={classes.faqDetails}>
						<Divider/>
						<Typography component={"div"} variant={"body1"}
						            style={{
							            backgroundColor: "#FFF",
							            width: 100,
							            marginTop: -16,
							            marginLeft: 80,
							            paddingLeft: 20
						            }}>
							Anteprima
						</Typography>
						<AccordionFaq risposta={stateToHTML(convertFromRaw(JSON.parse(watch("risposta"))))}
						              domanda={watch("domanda")}/>
					</Grid>}
				</Grid>
			</form>
		</React.Fragment>
	);
};

export default React.memo(FaqForm);
